<template>
	<it-link :to="route" :class="cls" @click.native="markLastUse" v-bind="linkExtraBind">
		<sym-icon v-if="hasIcon" :name="mi.icon"></sym-icon>
		<span v-if="hasTitle" class="tab-label">{{ mi.title }}</span>
		<span v-if="hasBadge" class="tab-badge">{{ mi.badge }}</span>
	</it-link>
</template>

<script setup lang="ts">
import {markItemAsRecent, MenuItem} from "@t/ui/Menu";
import {supportBadges, isNav, hasChildren, mostRecentNavigationChild} from "@t/ui/Menu";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {computed} from "vue";
import ItLink from "@/router/ItLink.vue";

const props = defineProps<{
	mi:MenuItem,
	level:number,
	active: boolean,
	minify?: boolean
}>();

const cls = computed<string[]>(() => {
	const c = [ "tab" ];
	c.push("tab-level-" + props.level);
	if (props.active) c.push("tab-active");
	return c;
});

const route = computed<string>(() => {
	if (isNav(props.mi)) return props.mi.link;
	else if (hasChildren(props.mi)) {
		let recent = mostRecentNavigationChild(props.mi);
		if (recent) return recent.link;
	}
	return "notFound.do";
});

const hasIcon = computed<boolean>(() => {
	return !!props.mi.icon;
});

const hasTitle = computed<boolean>(() => {
	if (props.minify && hasIcon.value) return false;
	return !!props.mi.title;
});

const hasBadge = computed<boolean>(() => {
	if (props.minify) return false;
	return supportBadges(props.mi) && !!props.mi.badge;
});

function markLastUse() {
	markItemAsRecent(props.mi);
}

const linkExtraBind = computed(() => {
	const bind:any = {};
	if (props.minify) {
		let title:string[] = [];
		if (!!props.mi.title) title.push(props.mi.title);
		if (supportBadges(props.mi) && !!props.mi.badge) {
			title.push("("+props.mi.badge+")")
		}
		bind.title = title.join(" ");
	}
	if (props.mi.name) bind['data-name'] = props.mi.name;
	return bind;
});

</script>

<style>

</style>